import { authenticationService } from "@authentication/services/AuthenticationService";

export const weededDocumentsApi = {
  // Weed out a document
  weedoutDocument: async (documentPid) => {
    const response = await authenticationService._makeRequest(
      "post",
      `/custom/weeding/documents/${documentPid}/weedout`
    );
    return response.data;
  },

  // Get all weeded documents
  getWeededDocuments: async () => {
    const response = await authenticationService._makeRequest(
      "get",
      "/custom/weeding/weeded"
    );
    return response.data;
  },

  // Restore multiple documents
  restoreDocuments: async (documentIds) => {
    const response = await authenticationService._makeRequest(
      "post",
      "/custom/weeding/restore",
      { document_ids: documentIds }
    );
    return response.data;
  },

  // Permanently delete multiple documents
  deleteDocuments: async (documentIds) => {
    const response = await authenticationService._makeRequest(
      "post",
      "/custom/weeding/delete",
      { document_ids: documentIds }
    );
    return response.data;
  },

  // Apply weeding threshold
  applyThreshold: async (thresholdYears) => {
    const response = await authenticationService._makeRequest(
      "post",
      "/api/custom/weeding/apply",
      { threshold_years: thresholdYears }
    );
    return response.data;
  },

  // Get flagged documents
  getFlaggedDocuments: async () => {
    const response = await authenticationService._makeRequest(
      "get",
      "/api/custom/weeding/flagged"
    );
    return response.data;
  },

  // Test endpoint
  testConnection: async () => {
    const response = await authenticationService._makeRequest(
      "get",
      "/api/custom/weeding/test"
    );
    return response.data;
  },
};
